import React, { createContext, useContext, useState } from 'react';

const CredentialsContext = createContext({
  apiKey: null,
  setCredentials: () => {},
  clearCredentials: () => {},
  hasValidCredentials: () => false
});

export const CredentialsProvider = ({ children }) => {
  // Keep API key only in memory - no persistence for security
  const [apiKey, setApiKey] = useState(null);

  const setCredentials = (newApiKey) => {
    if (!newApiKey) {
      console.error('Invalid API key provided');
      return;
    }

    // Only store in memory, not in localStorage/sessionStorage for security
    setApiKey(newApiKey);
  };

  const clearCredentials = () => {
    setApiKey(null);
  };

  const hasValidCredentials = () => {
    return Boolean(apiKey);
  };

  const value = {
    apiKey,
    setCredentials,
    clearCredentials,
    hasValidCredentials
  };

  return (
    <CredentialsContext.Provider value={value}>
      {children}
    </CredentialsContext.Provider>
  );
};

export const useCredentials = () => {
  const context = useContext(CredentialsContext);

  if (!context) {
    throw new Error('useCredentials must be used within a CredentialsProvider');
  }

  return context;
};

export default CredentialsContext;
